var Theme = Theme || {};

Theme.GuestCheckout = (function ($) {
    return {
        init: _init
    };

    function _init() {
        $(document.body).on('click', '.guest-checkout-form .js-btn-guest-checkout', function (e) {
            var $guestCheckoutForm = $(this).closest('.guest-checkout-form');
            e.preventDefault();
            e.stopPropagation();
            checkoutAsGuest($guestCheckoutForm);
        });

        $(document.body).on('click', '.restore-access-form .js-btn-restore-guest-access', function (e) {
            var $restoreAccessForm = $(this).closest('.restore-access-form');
            e.preventDefault();
            e.stopPropagation();
            restoreGuestAccess($restoreAccessForm);
        });
    }

    function checkoutAsGuest($guestCheckoutForm) {
        var $emailInput = $('.guest-email');
        var guestEmail = $emailInput.val();
        var $error = $guestCheckoutForm.find('.error:not(.js-error-length)');
        var $errorLength = $guestCheckoutForm.find('.js-error-length');

        if (!_validateEmail(guestEmail, $emailInput, $error, $errorLength)) {
            return;
        }

        $.post('/store/GuestLogin/Ajax', { guestEmail: guestEmail })
            .then(function (result) {
                if (result.Success) {
                    window.location = '/store/reviewcart';
                }
                else if (result.Messages.length) {
                    $error.html(result.Messages[0]).show();
                }
            }).catch(function () {
                $error.html(result.Messages[0]).show();
            });
    }

    function restoreGuestAccess($restoreAccessForm) {
        var $emailInput = $('.restore-guest-email');
        var guestEmail = $emailInput.val();
        var $error = $restoreAccessForm.find('.error:not(.js-error-length)');
        var $errorLength = $restoreAccessForm.find('.js-error-length');
        var resourceId = $('#resourceId').val();
        var resourceType = $('#resourceTypeId').val();
        var resourceUrl = window.location.href;

        var valid = _validateEmail(guestEmail, $emailInput, $error, $errorLength);
        $emailInput.attr('aria-invalid', valid ? 'false' : 'true');
        if (!valid) {
            return;
        }

        $.post('/store/SendRestoreAccessLink/Ajax', { guestEmail: guestEmail, resourceUrl: resourceUrl, resourceId: resourceId, resourceType: resourceType })
            .then(function (result) {
                if (result.Success) {
                    $('.restore-access-form').html('<p style="color:green;">' + result.Messages[0] + '</p >');
                }
                else if (result.Messages.length) {
                    $emailInput.attr('aria-invalid', 'true');
                    SCM.Announce.alert($error, result.Messages[0]);
                }
            }).catch(function () {
                $emailInput.attr('aria-invalid', 'true');
                SCM.Announce.alert($error);
            });
    }

    function _validateEmail(email, $emailInput, $error, $errorLength) {
        if (_isEmailTooLong(email, $emailInput)) {
            $error.hide();
            SCM.Announce.alert($errorLength);
            return false;
        }

        if (!SCM.JSUtility.isValidEmail(email)) {
            $errorLength.hide();
            SCM.Announce.alert($error);
            return false;
        }

        $error.hide();
        $errorLength.hide();
        return true;
    }

    function _isEmailTooLong(email, $emailInput) {
        var maxLength = $emailInput.data('maxLength');
        return maxLength && email.length > maxLength;
    }
})(jQuery);